module.exports = __webpack_public_path__ + "media/assets/community_index/sort-icon-398cadf5dcd64e58bf9f68a283d4962bcdba787b952de468cca431843c851258.png";